import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SocialData } from '../assets/SocialData';
import '../style/Slider.css';
const MainSlider = ({ slider = [] }) => {
  let { type } = useParams();
  // console.log(SocialData);
  return (
    <>
      <Swiper
        style={{ maxHeight: '72vh' }}
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        loop={true}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className='mySwiper'
      >
        {slider?.slice(1, 5)?.map((slide, index) => {
          return (
            <>
              <SwiperSlide key={index}>
                <>
                  {/* Jumbotron */}
                  <div
                    className=' p-12 text-center relative overflow-hidden bg-no-repeat bg-cover '
                    style={{
                      backgroundImage:
                        'url(' +
                        `https://www.themoviedb.org/t/p/w1920_and_h800_multi_faces/${slide.backdrop_path}` +
                        ')',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center center',
                      height: '90vh',
                      width: '100%',
                    }}
                  >
                    <div
                      className='absolute top-0 right-0 bottom-0 left-0 w-full h-full overflow-hidden bg-fixed'
                      style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
                    >
                      <div className='flex  items-center h-full w-full '>
                        <div className='text-white text-left  md:mx-20 mx-10 max-w-4xl py-56'>
                          <h2
                            className='font-semibold text-4xl '
                            style={{ color: 'rgb(215, 215, 5)' }}
                          >
                            {slide?.original_title}
                          </h2>
                          <p className='font-medium text-sm '>
                            {/* {slide.overview.slice(0, 100)} */}
                            {slide?.overview} - {slide.overview.slice(0, 100)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Jumbotron */}
                </>
              </SwiperSlide>
            </>
          );
        })}
      </Swiper>
      {/* slider-footer_section */}
      <div className=' bg-colorTwo dark:colorTwo py-3'>
        {SocialData.map((item, index) => (
          <button
            key={index}
            type='button'
            className='py-2 px-4 mx-5 my-2 inline-flex justify-center items-center gap-2 rounded-md border-2 border-purple-200 font-semibold text-purple-200  hover:text-white hover:bg-purple-500 hover:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-200 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800'
          >
            {<item.icon />}
            {item.name}
            <FaArrowRight />
          </button>
        ))}
      </div>
    </>
  );
};

export default MainSlider;
